import { createListAtoms } from "../../common/DataList";

// ============================================================
// Liste des organisations — configuration pure (testable sans DOM) : filtres
// par défaut, définition du filtre principal, construction de la requête
// POST organizations/search { organization: { searchString, isCAF }, page, nbItemsByPage }.
// La recherche reste automatique (débounce de 800 ms), comme l'écran
// historique ; la dernière recherche est mémorisée entre deux visites.
// ============================================================

export const ORGANISATIONS_ENDPOINT = "organizations/search";
export const DELAI_RECHERCHE = 800;
export const ORGANISATIONS_DEFAULT_FILTERS = { terms: "", isCAF: false };
export const ORGANISATIONS_PERSIST_KEY = "espoar.boa.organisationList.search";

export const organisationsAtoms = createListAtoms({
  defaultFilters: ORGANISATIONS_DEFAULT_FILTERS,
  persistKey: ORGANISATIONS_PERSIST_KEY,
});

export const GROUPES_FILTRES_ORGANISATIONS = [{ id: "organisation", title: "Organisation" }];

// « Afficher la caf », seul filtre de la liste, est dans la barre de recherche.
// Côté API, il ne garde que la CAF et la CAF EG (règle sur le code).
export const definitionsFiltresOrganisations = () => [
  {
    name: "isCAF",
    group: "organisation",
    label: "Afficher la caf",
    type: "checkbox",
    principal: true,
  },
];

export function buildOrganisationsPayload(search) {
  const filters = (search && search.filters) || {};
  return {
    organization: {
      searchString: String(filters.terms || "").trim(),
      isCAF: !!filters.isCAF,
    },
    page: Number(search && search.page) || 1,
    nbItemsByPage: Number(search && search.nbItemsByPage) || 25,
  };
}
